import { axios } from "@/plugins/axios";

function getFlexibleLifeFondsDaten20() {
    return axios.post("?Mode=FlexibleLife&Function=FondsDaten20");
}

function getFlexibleLifeFondsDaten() {
    return axios.post("?Mode=FlexibleLife&Function=FondsDaten");
}

function getVollwertFondsDaten() {
    return axios.post("?Mode=VollWert&Function=FondsDaten");
}

export {
    getFlexibleLifeFondsDaten20,
    getFlexibleLifeFondsDaten,
    getVollwertFondsDaten,
};
